import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import iaqSensorDataType from '../types/iaqSensorData.type';

export const getIAQSensorData = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getIAQSensorDataStart());
		let url = URLConstants.GetIAQIndexDecodedDataByID + '/' + data.Model +'/' + data.ICCID  + '?pageNo=' + data.CurrentPage + '&pageSize=' +  data.PageSize+ '&orderBy=' + data.OrderBy;
		services.get(url)
			.then(response => {
				dispatch(getIAQSensorDataSuccess({...response.data, ICCID: data.ICCID}));
			})
			.catch(err => {
				dispatch(getIAQSensorDataError(err));
			});
	};
};

const getIAQSensorDataStart = () => {
	return {
		type: iaqSensorDataType.GET_IAQ_SENSOR_DATA_START
	};
};

const getIAQSensorDataSuccess = (data: any) => {
	return {
		type: iaqSensorDataType.GET_IAQ_SENSOR_DATA_SUCCESS,
		payload: data
	};
};

const getIAQSensorDataError = (data: any) => {
	return {
		type: iaqSensorDataType.GET_IAQ_SENSOR_DATA_ERROR,
		payload: data
	};
};

export const resetGetIAQSensorDataState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetIAQSensorDataDispatcher());
	};
};

const resetGetIAQSensorDataDispatcher = () => {
	return {
		type: iaqSensorDataType.RESET_IAQ_SENSOR_DATA
	};
};